<template>
  <PageLayout :screenWidth="windowWidth" :loaded="meta.loaded">
    <section
      v-if="meta.loaded"
      class="app-section container-fluid p-0 m-0"
    >
      <div>
        <b-row>
          <b-col sm="12">
            <b-tabs
              id="wishlistNav"
              content-class="mt-3 ml-0"
              style="background: #f6f6f6;"
              justified
              :vertical="vertical"
              align="center"
              active-nav-item-class="font-weight-bold text-secondary"
              v-model="tabIndex"
            >
              <b-row>
                <b-col
                  class="pl-2 pr-2"
                  style="background: #f6f6f6;"
                  :sm="colWidth"
                >
                  <ImageFile :screenWidth="windowWidth" />
                </b-col>
                <b-col
                  class="pl-2 pr-2"
                  style="background: #f6f6f6;"
                  :sm="colBodyWidth"
                >
                  <b-tab
                    v-if="!friendsAndFamily"
                    title="Edit Your Website"
                    href="#Wishlist"
                    active
                    ><EditWishlist :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="
                      $store.state.wishlistType === 'wishlist' &&
                        !friendsAndFamily
                    "
                    href="#YourHoneymoon"
                    style="background: #f6f6f6;"
                    title="Your Honeymoon"
                    ><YourWishlist :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-else-if="
                      $store.state.wishlistType === 'giftlist' &&
                        !friendsAndFamily
                    "
                    href="#YourHoliday"
                    style="background: #f6f6f6;"
                    title="Your Holiday"
                    ><YourWishlist :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="!friendsAndFamily"
                    href="#ShareWishlist"
                    title="Share Your Wishlist"
                    style="background: #f6f6f6;"
                    ><GuestCardOrder :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="!friendsAndFamily"
                    href="#ViewContributions"
                    title="View Contributions"
                    style="background: #f6f6f6;"
                    ><Contributions :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="friendsAndFamily"
                    href="#FriendsAndFamilyWishlist"
                    title="Home"
                    style="background: #f6f6f6;"
                    ><FriendsAndFamilyWishlist :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="
                      friendsAndFamily &&
                        $store.state.wishlistType === 'wishlist'
                    "
                    href="#FriendsAndFamilyWedding"
                    title="Our Wedding"
                    style="background: #f6f6f6;"
                    ><FriendsAndFamilyWedding :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="
                      friendsAndFamily &&
                        $store.state.wishlistType === 'giftlist'
                    "
                    href="#FriendsAndFamilyWedding"
                    title="Our Holiday"
                    style="background: #f6f6f6;"
                    ><FriendsAndFamilyWedding :screenWidth="windowWidth"
                  /></b-tab>
                  <b-tab
                    v-if="friendsAndFamily"
                    href="#FriendsAndFamilyContributions"
                    title="Make A Contribution"
                    style="background: #f6f6f6;"
                    ><FriendsAndFamilyContributions :screenWidth="windowWidth"
                  /></b-tab>
                </b-col>
              </b-row>
            </b-tabs>
          </b-col>
        </b-row>
      </div>
    </section>
  </PageLayout>
</template>

<script>
import EditWishlist from "@/Components/EditWebsite/index.vue";
import YourWishlist from "@/Components/YourWishlist/index.vue";
import GuestCardOrder from "@/Components/GuestCardOrder/index.vue";
import Contributions from "@/Components/Contributions/index.vue";
import ImageFile from "@/Components/ImageFile/index.vue";
import FriendsAndFamilyWishlist from "@/Components/FriendsAndFamilyWishlist/index.vue";
import FriendsAndFamilyWedding from "@/Components/FriendsAndFamilyWedding/index.vue";
import FriendsAndFamilyContributions from "@/Components/FriendsAndFamilyContributions/index.vue";

export default {
  data() {
    return {
      meta: {
        loaded: false
      },
      tabIndex: 0,
      tabs: [
        "#Wishlist",
        "#YourHoneymoon",
        "#YourHoliday",
        "#ShareWishlist",
        "#ViewContributions"
      ],
      arr: [],
      colWidth: 4,
      colBodyWidth: 8,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      vertical: false,
      welcome_message: "",
      friendsAndFamily: false
    };
  },

  components: {
    EditWishlist,
    YourWishlist,
    GuestCardOrder,
    Contributions,
    ImageFile,
    FriendsAndFamilyWishlist,
    FriendsAndFamilyWedding,
    FriendsAndFamilyContributions
  },
  watch: {
    tabIndex() {
      this.$store.state.tabIdx = this.tabIndex;
      this.$store.dispatch("setTabIndexAction", this.$store.state.tabIdx);
    },
    friendsAndFamily() {
      if (this.$route.params.wishlistType === "friends-and-family") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (window.innerWidth < 790) {
        this.vertical = true;
      } else {
        this.vertical = false;
      }
      if (window.innerWidth <= 1367) {
        this.colWidth = "12";
        this.colBodyWidth = "12";
      } else {
        this.colWidth = "4";
        this.colBodyWidth = "8";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    if (this.$store.state.user.length === 0) {
      this.$router.push({ path: `/` });
    } else {
      this.meta.loaded = true;
    }

    if (this.$route.params.wishlistType === "friends-and-family") {
      this.friendsAndFamily = true;
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize());
    });
    this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash);
  }
};
</script>
<style>
#wishlistNav .col-auto {
  flex: 0 0 auto;
  width: 100% !important;
  max-width: 100%;
  text-align: center;
}
#wishlistNav .nav-tabs .nav-link {
  padding-top: 4%;
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: black;
  min-height: 50px;
}
.tab-content {
  background: #f6f6f6;
}
.logout-button .nav-tabs .nav-link {
  background: red;
  color: red !important;
}
</style>
